var _desc, _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDriverThumbnailLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 104,
    height: 104,
    viewBox: "0 0 104 104",
    role: "img",
    "aria-labelledby": titleId,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, "User profile icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", {
    id: "description"
  }, "A dark user silhouette centered on a gray square background.")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 104,
    height: 104,
    fill: "#a0a0a0ff"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "white"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 51.5,
    cy: 46.5,
    r: 7.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.5 53.5C44.873 53.5 39.5 58.873 39.5 65.5H63.5C63.5 58.873 58.127 53.5 51.5 53.5Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDriverThumbnailLight);
export default __webpack_public_path__ + "static/media/driver-thumbnail-light.8079515cd72a4849f0415d911ef5ab20.svg";
export { ForwardRef as ReactComponent };